import React from 'react';
import { Tabs, Popover } from 'antd';
import css from './PageLayoutTopMenu.less';
import { KdevIconFont } from '../../../KdevIconFont';
import { common_system_arrowxia } from '@kid/enterprise-icon/icon/output/icons';
import { Bind } from 'lodash-decorators';
import { PageLayoutTopAllMenu } from './PageLayoutTopAllMenu';
import { RealDOM, router } from '../../../../shared/libs';
import { CustomTopMenu } from './PageLayoutCustomMenu';
import classnames from 'classnames';
import { ITopMenuConfig, ITopMenuItem, ITopMenuSection } from './types';
import { TrackReport } from '../../../../shared/common/trackReport';
export interface ITopMenu_item {
    id: string;
    name: string;
    pathArr: string[];
}

export interface ITopMenuProps {
    menuConfig: ITopMenuConfig;
    showMore?: boolean;
    getKeyByPathName?: (url: string) => string;
    isShowAIDevOpsMenu?: boolean;
    saveSortList?: (list: ITopMenuItem[]) => void;
    showSectionTitle?: boolean;
    allMenuPaneFooter?: React.ReactElement | null;
    onFooterClick?: () => boolean;
    onBeforePush?(path: string): void;
    platform?: 'KDev' | 'KTest';
    getProductNameByUrl?(path: string): string; // 根据 path 获取项目名称
}

interface IState {
    morePopoverVisible: boolean;
    moreText: string;
}

let gloablCurrentName = '';

const AIDEVOPS_KEY = 'kate-flow';
const AIDEVOPS_MENU: ITopMenuItem = {
    key: AIDEVOPS_KEY,
    id: "1-666",
    name: "智能研发",
    webUrl: "https://kate.corp.kuaishou.com/flow",
    iconUrl: "https://h1.static.yximgs.com/udata/pkg/QA-SERVEREE-FE-OUT/menu-icon/new_kdev_deliver.svg",
    default: true,
    fixed: true,
    blank: true
}

export function getTopMenuCurrentName() {
    if (gloablCurrentName) {
        return `${gloablCurrentName}`;
    }
    return gloablCurrentName || '';
}

export class PageLayoutTopMenu extends React.Component<ITopMenuProps, IState> {
    wrapperDom = new RealDOM();
    customMenuRef = React.createRef<CustomTopMenu>();

    historyListener: any = null;

    state: IState = {
        morePopoverVisible: false,
        moreText: '更多',
    };

    componentDidMount(): void {
        // 用来选中
        this.historyListener = router.routerProps.history.listen(() => {
            this.setState({});
        });
    }

    componentWillUnmount(): void {
        this.historyListener?.();
        gloablCurrentName = '';
    }

    convertMenuList(respData) {
        const menuMap = {};

        const defaultSelfTopGuideList: string[] = [];

        (respData?.allTopGuideList || []).forEach((section) => {
            section.children.forEach((menu) => {
                if (menu && menu.webUrl) {
                    menuMap[menu.webUrl] = menu;
                    if (menu.default === true) {
                        defaultSelfTopGuideList.push(menu.webUrl);
                    }
                }
            });
        });

        const topMenuList = (
            respData?.selfTopGuideList || defaultSelfTopGuideList
        )
            .map((item) => menuMap[item])
            .filter((item) => !!item);

        return {
            topMenuList: topMenuList || [],
            allMenuList: respData?.allTopGuideList || [],
            allMenuMap: menuMap || {},
        };
    }

    hasAidevopsMenu(list: ITopMenuItem[]) {
        return list.find(item => item.key === AIDEVOPS_KEY)
    }

    @Bind
    handleMenuDataFromProps(): {
        activeKey: string;
        moreText: string;
        allMenuList: ITopMenuSection[];
        topMenuList: ITopMenuItem[];
        currentName: string;
    } {
        const { topMenuList, allMenuList, allMenuMap } = this.convertMenuList(
            this.props.menuConfig
        );
        if (!topMenuList || !allMenuMap) {
            return {
                activeKey: '',
                currentName: '',
                moreText: '更多',
                allMenuList: [],
                topMenuList: [],
            };
        }

        let activeKey = this.props.getKeyByPathName?.(location.pathname) || '';
        let moreText = '更多';
        let currentName = '';

        const exist = topMenuList.find((item) => item.webUrl === activeKey);

        if (exist) {
            currentName = exist.name;
        }

        if (!exist) {
            const item = allMenuMap[activeKey];
            if (item) {
                moreText = item.name;
                activeKey = 'more';
                currentName = item.name;
            }
        }

        // 添加智能交付菜单：判断是否是白名单用户
        if (this.props.isShowAIDevOpsMenu) {
            if (!this.hasAidevopsMenu(topMenuList)) {
                topMenuList.splice(1, 0, { ...AIDEVOPS_MENU });
            }
            allMenuList.forEach((item) => {
                if (item.groupId === '1') { // 研发域
                    if (!this.hasAidevopsMenu(item.children)) {
                        item.children?.splice(1, 0, { ...AIDEVOPS_MENU });
                    }
                }
            });
        }

        return {
            activeKey,
            moreText,
            allMenuList,
            topMenuList,
            currentName,
        };
    }

    @Bind
    onTabChange(topMenuList: ITopMenuItem[], activeKey: string) {
        if (activeKey === 'more') {
            this.onMorePopoverVisibleChange(!this.state.morePopoverVisible);

            return;
        }

        const item = topMenuList.find((item) => item.webUrl === activeKey);

        const path = item?.webUrl || '';

        this.handelClick(path, item?.blank || false);
    }

    @Bind
    onMorePopoverVisibleChange(visible: boolean) {
        this.setState({
            morePopoverVisible: visible,
        });
    }

    @Bind
    private handelClick(path: string, blank = false) {
        const PERSONAL_WORK_BENCH_BRANCHVIEW = '/web/workbench/branchView';
        const BIZ_SPACE = '/web/workbench/bizspace';

        if (path === BIZ_SPACE) {
            path =
                localStorage.getItem('last_bizSpace_visit_router') ||
                PERSONAL_WORK_BENCH_BRANCHVIEW;
        }

        if (blank) {
            window.open(path, '_blank');
            return;
        }

        if (/^https?/.test(path)) {
            window.location.href = path;
            return;
        }

        if (
            window.location.pathname === path ||
            this.getProductNameByUrl(path) !==
            this.getProductNameByUrl(window.location.pathname)
        ) {
            window.location.href = path; // router.getUrlString(path);
            return;
        }

        router.push(path);
    }

    private getProductNameByUrl(path: string) {
        // 如果传入则使用传入方法获取
        if (this.props.getProductNameByUrl) {
            return this.props.getProductNameByUrl(path);
        }

        if (!path) return '';

        if (path[0] !== '/') {
            path = '/' + path;
        }

        return path.split('/')[2] || '';
    }

    @Bind
    renderAllContent(
        allMenuList: ITopMenuSection[],
        topMenuList: ITopMenuItem[]
    ) {
        return (
            <TrackReport trackInfo={'更多'}>
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <PageLayoutTopAllMenu
                        allMenuList={allMenuList}
                        onMenuClick={(webUrl, blank) => {
                            this.onMorePopoverVisibleChange(false);
                            this.handelClick(webUrl, blank);
                        }}
                        onClose={() => {
                            this.onMorePopoverVisibleChange(false);
                            this.customMenuRef.current?.show({
                                topMenuList: topMenuList,
                                allMenuList: allMenuList,
                            });
                        }}
                        onFooterClick={() => {
                            const result = this.props.onFooterClick?.();
                            if (result) {
                                this.onMorePopoverVisibleChange(false);
                            }
                        }}
                        showSectionTitle={this.props.showSectionTitle}
                        allMenuPaneFooter={this.props.allMenuPaneFooter}
                        platform={this.props.platform || 'KDev'}
                    />
                </div>
            </TrackReport>
        );
    }

    @Bind
    renderAllMenuPopover(
        moreText: string,
        allMenuList: ITopMenuSection[],
        topMenuList: ITopMenuItem[]
    ) {
        return (
            <Popover
                visible={this.state.morePopoverVisible}
                placement="topLeft"
                title={null}
                onVisibleChange={this.onMorePopoverVisibleChange}
                destroyTooltipOnHide
                content={this.renderAllContent(allMenuList, topMenuList)}
                trigger="click"
                overlayClassName={css.topMenuOverlay}
                getPopupContainer={() => this.wrapperDom.dom || document.body}
                data-track-process="更多"
            >
                <span
                    className={classnames(
                        css.moreText,
                        this.state.morePopoverVisible && css.active
                    )}
                    data-track-process="更多"
                >
                    {moreText}
                    <span className={css.iconBox}>
                        &thinsp;
                        <KdevIconFont
                            className={css.icon}
                            id={common_system_arrowxia}
                        />
                    </span>
                </span>
            </Popover>
        );
    }

    render() {
        const { moreText, activeKey, allMenuList, topMenuList, currentName } =
            this.handleMenuDataFromProps();

        const showMore = this.props.showMore === false ? false : true;
        gloablCurrentName = currentName || '';

        if (!topMenuList || !topMenuList.length) {
            return null;
        }

        return (
            <TrackReport trackInfo="顶部导航">
                <div className={css.topMenuBox} ref={this.wrapperDom.setDom}>
                    <Tabs
                        className={css.topMenuTabs}
                        onChange={(activeKey) =>
                            this.onTabChange(topMenuList, activeKey)
                        }
                        activeKey={activeKey}
                        defaultActiveKey={activeKey}
                    >
                        {/*  用来没有选中态兜底使用 */}
                        <Tabs.TabPane
                            tab={<div style={{ display: 'none' }}></div>}
                            key={''}
                        ></Tabs.TabPane>

                        {topMenuList.map((item: ITopMenuItem) => {
                            return (
                                <Tabs.TabPane
                                    tab={
                                        <div
                                            style={{
                                                position: 'relative',
                                                fontFamily: 'PingFang SC',
                                            }}
                                            data-track-process={item.name}
                                        >
                                            <span
                                                className={css.tabBold}
                                                style={{
                                                    fontWeight: '700',
                                                    opacity: 0,
                                                }}
                                            >
                                                {item.name}
                                            </span>
                                            <span className={css.tabDefault}>
                                                {item.name}
                                            </span>
                                        </div>
                                    }
                                    key={item.webUrl}
                                ></Tabs.TabPane>
                            );
                        })}

                        {showMore && topMenuList && topMenuList.length && (
                            <Tabs.TabPane
                                tab={this.renderAllMenuPopover(
                                    moreText,
                                    allMenuList,
                                    topMenuList
                                )}
                                key={'more'}
                            ></Tabs.TabPane>
                        )}
                    </Tabs>
                </div>
                <CustomTopMenu
                    ref={this.customMenuRef}
                    onSave={async (list) => {
                        if (this.props.saveSortList) {
                            await this.props.saveSortList(list);
                        }
                        this.customMenuRef.current?.hide();
                    }}
                />
            </TrackReport>
        );
    }
}
